/* eslint-disable radix */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable max-len */
/* eslint-disable arrow-body-style */
import React from 'react';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';

export default function OrderLevelProgress({ OrderDetails }) {
    const getPercentage = () => {
        const aprrovalEachPercentage = 100 / OrderDetails.approvals.approval.length;
        let total = 0;
        OrderDetails.approvals.approval.map((item) => {
            total += parseInt(item.status) === 1 ? 1 : 0;
        });
        return aprrovalEachPercentage * total;
    };
    return (
        <>
            <ProgressBar
                percent={getPercentage() || 0}
                filledBackground="green"
            >
                {OrderDetails?.approvals?.approval.map((item, index) => (
                    <Step transition="scale">
                        {({ accomplished }) => (
                            <img
                                width="10"
                                className="min-w-[18px] min-h-[22px] z-10"
                                src={`${!accomplished ? '/images/circle-orange.svg' : '/images/circle-gren.svg'}`}
                            />
                        )}
                    </Step>
                ))}
            </ProgressBar>
        </>
    );
}
